<template>
  <div class="compte" :class="{ marginBandeau: $store.state.bandeau != 0 }">
    <Tabs cache-lifetime="0" :options="{ useUrlFragment: false, defaultTabHash: defaultTab }">
      <Tab name="Mes alertes" id="0">
        <MesAlertes />
      </Tab>

      <Tab name="Mes informations" id="1">
        <MesInfos ref="infos" />
      </Tab>

      <Tab name="Mon Pass" id="2">
        <MonPass ref="monpass" />
      </Tab>

      <Tab name="Contenu" id="3">
        <div class="simpleForm compteTab">
          <div>
            <label> Theme des icônes : </label>
            <label> Afficher la version : </label>
          </div>
          <div>
            <div>
              <select v-model="$store.state.iconTheme" @change="themeChanged">
                <option value="pink">
                  Rose
                </option>
                <option value="grey">
                  Original
                </option>
                <option value="color">
                  Couleur
                </option>
              </select>
            </div>
            <div>
              <input
                v-model="$store.state.showVersion"
                @change="showVersionChanged"
                true-value="yes"
                false-value="no"
                type="checkbox"
              />
            </div>
          </div>
        </div>
      </Tab>

      <Tab name="Confidentialité" id="4">
        <Confidentialite ref="confidentialite" />
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import { Tabs, Tab } from "vue-tabs-component";

import BasePage from "@/components/pages/BasePage";
import MesAlertes from "@/components/compte/MesAlertes";
import MesInfos from "@/components/compte/MesInfos";
import Confidentialite from "@/components/compte/Confidentialite";
import MonPass from "@/components/compte/MonPass";
import Vue from "vue";

export default {
  name: "Compte",
  components: {
    Tabs,
    Tab,
    MesAlertes,
    MesInfos,
    MonPass,
    Confidentialite
  },
  extends: BasePage,
  data() {
    return {
      msg: "Mon Compte"
    };
  },

  computed: {
    defaultTab() {
      if (this.$route.query.tab == null) {
        return "0";
      }
      return this.$route.query.tab;
    }
  },
  methods: {
    themeChanged: function() {
      localStorage["icon-theme"] = this.$store.state.iconTheme;
    },

    showVersionChanged: function() {
      localStorage["show-version"] = this.$store.state.showVersion;
    },

    init: async function() {
      await Vue.nextTick();

      this.$refs.infos.init();
      this.$refs.monpass.init();
      this.$refs.confidentialite.init();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/base.scss";
@import "@/assets/css/vars.scss";
@import "@/assets/css/forms.scss";
@import "@/assets/css/compte.scss";
.cptBandeau {
  margin-top: 120px;
}
</style>
